import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Row, Spin, Icon, Form, Input } from "antd";
import { injectIntl, FormattedMessage } from "react-intl";
import messages from "./messages";
import Flexbox from "flexbox-react";
import history from "../../history";
import image from "../../assets/images/005_2202_cut.jpg";
import Button from "../Button/index";
import SurveyHeader from "../SurveyHeader/SurveyHeader";
import SurveyFooter from "../SurveyFooter/SurveyFooter";
import surveyActions from "../../actions/survey";
import authActions from "../../actions/auth";
import ls from "local-storage";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin/>;
const FormItem = Form.Item;

class SurveyGreeting extends Component{
	constructor(props) {
		super(props);
		this.state = {
			enterEmail: ""
		};
	}
	
	componentDidMount() {
		authActions.getUserById(this.props.auth);
	}
	
	componentWillReceiveProps({ auth }) {
		if (!this.props.auth && auth) {
			authActions.getUserById(auth);
		}
	}
	
	validateField = () => {
		this.props.form.validateFieldsAndScroll((err, values) => {
			if (!err && values.email) {
				console.log(values.email);
				this.setState({
					enterEmail: values.email
				});
			} else {
				this.setState({
					enterEmail: ""
				});
			}
		});
	};
	startSurvey = () => {
		this.validateField();
		if (this.state.enterEmail) {
			authActions.enterEmail(this.state.enterEmail);
			ls.set("email", this.state.enterEmail);
		} else if (this.props.email) {
			authActions.enterEmail(this.props.email);
		}
		history.push("/survey/0");
		surveyActions.startSurvey();
	};
	onChange = (e) => {
		e.preventDefault();
		this.validateField();
	};
	
	render() {
		const { auth, email, isLoading, form: { getFieldDecorator }, intl: { formatMessage } } = this.props;
		if (isLoading) {
			return (
				<Row type='flex' justify='center' align='middle' className='Spin'>
					<Spin indicator={antIcon}/>
				</Row>
			);
		}
		return (
			<Row type='flex' align='middle' justify='center' className='SurveyGreeting'>
				<Col md={12} xs={0} sm={0} className='Image'>
					<img className='logo' src={image} alt="logo"/>
				</Col>
				<Col md={12} xs={24} sm={24} className='Content'>
					<SurveyHeader/>
					<Flexbox alignItems='center' flexDirection='column' className='Card'>
						<h2>
							<FormattedMessage {...messages.title} />
						</h2>
						<p>
							<FormattedMessage {...messages.subtitle} />
						</p>
						{email && auth ? null : <Form style={{ width: "80%" }} onChange={this.onChange}>
							<FormItem>
								{getFieldDecorator("email", {
									initialValue: ls.get("email"),
									rules: [
										{
											type: "email",
											message: formatMessage(messages.emailInValid)
										},
										{
											message: formatMessage(messages.email)
										}
									]
								})(<Input placeholder={formatMessage(messages.placeholder)}/>)}
							</FormItem>
						</Form>}
						<Button
							onClick={this.startSurvey}
							type="primary">
							<FormattedMessage {...messages.button} />
						</Button>
					</Flexbox>
					<SurveyFooter/>
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = ({ user: { email, auth, isLoading } }) => {
	return {
		email, auth, isLoading
	};
};

export default injectIntl(connect(mapStateToProps)(Form.create()(SurveyGreeting)));




// WEBPACK FOOTER //
// ./src/components/SurveyGreeting/SurveyGreeting.js